module.exports = __webpack_public_path__ + "bdb6984ca426069d3403cd69b730bc18.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/20211001_120312.jpg
// module id = 371
// module chunks = 0